<template>
  <div class="IndexSearch">
    <div class="module head">
        <h1>高薪优质金融资本职位任你选</h1>
        <div class="desp">
          <p>快速对接，让你步入职场快车道</p>
          <div class="swiper-container scroll-txt" id="ScrollTxt">
            <div class="swiper-wrapper">

              <div class="swiper-slide stop-swiping" v-for="(item, index) in rolllist" :key="index">
                <div>
                  <!-- scroll-txt -->
                  <span class="name">{{item.customername}}</span>
                  <span class="status">确认Offer</span>
                  <span class="company">{{item.jobname}}</span>
                  <span class="money">年薪{{item.factsalary}}万</span>
                  <span class="time">{{item.datetime}}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="form">
            <div class="form-item options">
              <el-input v-model="form.key" placeholder="请输入职位名称" style="width: 340px;"></el-input>
            </div>
            <div class="form-item city">
              <el-select v-model="form.jobplace" placeholder="请选择城市" style="width: 246px;">
                <el-option v-for="(item, index) in cityList" :key="index" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </div>
            <div class="form-item annual-salary-list">
              <el-select v-model="form.activeAnnualSalary" placeholder="请选择年薪" style="width: 246px;">
                <el-option v-for="(item, index) in annualSalaryList" :key="index" :label="item.name" :value="item.code" ></el-option>
              </el-select>
            </div>
            <div class="form-item">
              <el-button type="primary" @click="goto"><img src="@/common/images/talent/index/search.png"/><p>搜索</p></el-button>
            </div>
        </div>
        <!-- end 搜索表单 -->

        <div class="host-opcations">
            <span class="txt">热门岗位：</span>
            <span v-for="(item, index) in hostOpcations" :key="index" @click="activeType(item.jobtypecode01, item.jobtypecode02)">{{item.name}}</span>
        </div>
        <!-- end 热门岗位标签 -->
    </div>
    <div class="card">
      <div class="module">
            <div class="card-item" @click="activeType('01')">
              <div>
                <img src="@/common/images/talent/index/card (1).png" alt="董秘类">
                <img class="active" src="@/common/images/talent/index/card.png" alt="董秘类">
                <p>董秘类</p>
              </div>
            </div>
            <div class="card-item" @click="activeType('02')">
              <div>
                <img src="@/common/images/talent/index/card (4).png" alt="财务类">
                <img class="active" src="@/common/images/talent/index/card (6).png" alt="财务类">
                <p>财务类</p>
              </div>
            </div>
            <div class="card-item" @click="activeType('03')">
              <div>
                <img src="@/common/images/talent/index/card (5).png" alt="人力类">
                <img class="active" src="@/common/images/talent/index/card (7).png" alt="财务类">
                <p>人力类</p>
              </div>
            </div>
            <div class="card-item" @click="activeType('04')">
              <div>
                <img src="@/common/images/talent/index/card (2).png" alt="投资类">
                <img class="active" src="@/common/images/talent/index/card (8).png" alt="财务类">
                <p>投资类</p>
              </div>
            </div>
            <div class="card-item" @click="goto()">
              <div>
                <img src="@/common/images/talent/index/card (3).png" alt="更多岗位">
                <img class="active" src="@/common/images/talent/index/card (9).png" alt="财务类">
                <p>更多岗位</p>
              </div>
            </div>
      </div>
      <!-- end 更多岗位推荐 -->
    </div>
  </div>
  <!-- end 主页搜索栏 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.min.css'
import type from '../../components/type.json'
import annualSalaryLists from '../../components/YearMoneyType.json'
import cityLists from '../../components/cityList.json'
export default {
  name: 'IndexSearch',
  props: ['rolllist'],
  data () {
    return {
      cityList: cityLists, // 城市列表
      annualSalaryList: annualSalaryLists, // 年薪列表
      hostOpcations: [],  // 热门岗位 通过 引入 type 文件进行配置
      form: {
        key: '',  // 职位
        activeAnnualSalary: "", // 选中年薪
        jobplace: '', // 工作城市,
        jobtypecode01: '',  // 行业code 一级
        jobtypecode02: ''   // 行业code 二级
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.inifSwiper()
    })

    // 配置热门岗位 循环 type 文件 
    for (let i = 0; i < type.length; i++) {
      let items = type[i].list
      for (let j = 0; j < items.length; j++) {
        //  host 为1时 即为热门岗位
        if (items[j].host == 1) {
          this.hostOpcations.push(
            {
              name: items[j].name,
              jobtypecode01: type[i].code,
              jobtypecode02: items[j].code
            }
          )
        }
      }
    }
  },
  updated() {
    this.inifSwiper()
  },
  methods: {
      inifSwiper() {
        new Swiper('#ScrollTxt.swiper-container', {
          autoplay: {
            delay: 3000,//3秒切换一次
          },
          loop : true,
          direction : 'vertical',
          noSwiping : true,
          noSwipingClass : 'stop-swiping',
        })
      },
      activeType(jobtypecode01, jobtypecode02) {  // 选中类别
        if (jobtypecode01) {
          this.form.jobtypecode01 = jobtypecode01
        }
        if (jobtypecode02) {
          this.form.jobtypecode02 = jobtypecode02
        }
        this.goto()
      },
      goto() {
        this.$router.push({
          name: "TalentSearch",
          query: this.form
        })
      },
       ...mapActions([
            'setLoading',
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      
  }
}
</script>

<style lang="scss" type="text/scss">
.IndexSearch {
  position: relative;
  height: 724px;
  background:url('../../../../common/images/talent/index/index-search.png') no-repeat center center;
  background-size: 1920px 724px;
  .head {
    width: 1140px;
    h1 {
      padding-top: 160px;
      font-size: 50px;
      color: #fff;
      font-weight: bold;
    }
  }
  .desp {
    margin-top: 10px;
    height: 40px;
    overflow: hidden;

    p {
      float: left;
      color: #fff;
      font-size: 20px;
      line-height: 40px;
    }
    .scroll-txt {
      float: right;
      padding: 0 20px;
      box-sizing: border-box;
      width: 420px;
      height: 40px;
      background:rgba(255,255,255,0.15);
      border-radius:20px;
      border:1px solid rgba(121,121,121,1);
      line-height: 40px;
      span {
        float: left;
        display: block;
        margin-right: 25px;
        color: #fff;
        font-size: 14px;
        
        &:last-child {
          float: right;
          margin-right: 0;
        }

        &.status {
          color: #FF7F04;
        }
        &.money {
          color: #5EBDFF;
          width: 70px;
          margin-right: 12px;
        }
        &.company {
          max-width: 95px;
          margin-right: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

  }
  .form {
    margin-top: 20px;
    padding: 30px;
    width:1140px;
    height:110px;
    box-sizing: border-box;
    background:rgba(255,255,255,0.15);

    .form-item {
      float: left;
      position: relative;
      
      img+p {
        display: inline-block;
        transform: translateY(-3px);
        -ms-transform: translateY(-3px);
        -moz-transform: translateY(-3px);
        -o-transform: translateY(-3px);
        -webkit-transform: translateY(-3px);
      }
      img {
        margin-right: 7px;
        display: inline-block;
        width: 20px;
        height: 20px;
        transform: translateY(2px);
        -webkit-transform: translateY(2px);
        -ms-transform: translateY(2px);
        -moz-transform: translateY(2px);
        -o-transform: translateY(2px);
      }
      .el-input,
      .el-select {
        margin-right: 30px;

        .el-input__inner,
        .el-input--suffix .el-input__inner {
          padding-left: 50px;
          height: 50px;
        }
      }
      .el-button {
        width: 158px;
        height: 50px;
      }

      &.options .el-input::before {
        content: '';
        position: absolute;
        top: 15px;
        left: 15px;
        z-index: 2;
        display: block;
        width: 20px;
        height: 20px;
        background: url('../../../../common/images/talent/index/form (1).png') no-repeat;
        background-size: 20px;
      }
      &.city .el-select::before {
        content: '';
        position: absolute;
        top: 15px;
        left: 15px;
        z-index: 2;
        display: block;
        width: 20px;
        height: 20px;
        background: url('../../../../common/images/talent/index/form (3).png') no-repeat;
        background-size: 20px;
      }
      &.annual-salary-list .el-select::before {
        content: '';
        position: absolute;
        z-index: 2;
        display: block;
        top: 15px;
        left: 15px;
        width: 20px;
        height: 20px;
        background: url('../../../../common/images/talent/index/form (2).png') no-repeat;
        background-size: 20px;
      }
    }
  }
  .host-opcations {
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    .txt {
      padding-left: 26px;
      background: url('../../../../common/images/talent/index/host.png') no-repeat;
      background-size: 14px 19px;
      background-position: left center;
    }
    span {
      margin-right: 20px;
      &~span {
        cursor: pointer;
      }
      &~span:hover {
        color: #409EFF;
      }
    }
  }

  .card {
    position: absolute;
    bottom: 0;
    width: 100%;
    height:130px;
    background:rgba(255,255,255,0.15);

    .module {
      .card-item {
        position: relative;
        float: left;
        width: calc(100% / 5);
        height: 130px;
        box-sizing: border-box;
        border-right: solid 1px rgba(255, 255, 255, .5);
        cursor: pointer;

        div:hover {
          padding: 10px;
          margin-top: -10px;
          margin-left: -10px;
          box-shadow:0px 0px 12px 0px rgba(0,0,0,0.3);
          -webkit-box-shadow:0px 0px 12px 0px rgba(0,0,0,0.3);
          -ms-box-shadow:0px 0px 12px 0px rgba(0,0,0,0.3);
          -moz-box-shadow:0px 0px 12px 0px rgba(0,0,0,0.3);
          -o-box-shadow:0px 0px 12px 0px rgba(0,0,0,0.3);
          transition: all .5s;
          -webkit-transition: all .5s;
          -ms-transition: all .5s;
          -moz-transition: all .5s;
          -o-transition: all .5s;
          background: #5EBDFF;
          img {display: none;}
          img.active {
            display: block;
          }
        }


        &:first-child {
          border-left: solid 1px rgba(255, 255, 255, .5);
        }

        div {
          position: absolute;
          width: 240px;
          height: 130px;
          font-size: 16px;
          color: #fff;
          text-align: center;
          transition: all .5s;
          -webkit-transition: all .5s;
          -ms-transition: all .5s;
          -moz-transition: all .5s;
          -o-transition: all .5s;

          img {
            display: block;
            margin: auto;
            margin-top: 30px;
            width: 35px;
            height: 35px;
          }

          img.active {
            display: none;
          }

          p {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>